module.exports = __webpack_public_path__ + "static/media/lc50-1.67e07acc.png";